module.exports = __webpack_public_path__ + "static/media/1015091.0c57678d.jpg";